import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { onAuthStateChanged } from 'firebase/auth';
import { CircularProgress, Box } from '@mui/material';
import { autenticazione } from '../firebase/config';
import { setUser, setLoading, logout } from '../store/slices/authSlice';
import { authService } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    let isMounted = true;
    
    const unsubscribe = onAuthStateChanged(autenticazione, async (firebaseUser) => {
      if (!isMounted) return;
      
      dispatch(setLoading(true));
      
      if (firebaseUser) {
        // Se c'è un utente Firebase, aggiorna lo stato
        try {
          const userData = await authService.getUserData(firebaseUser.uid);
          if (isMounted) {
            // Transform Firebase Timestamp objects to serializable format
            const serializableUserData = {
              uid: firebaseUser.uid,
              email: firebaseUser.email,
              ...userData,
            };
            
            // Convert Firebase Timestamp to ISO string if present
            if (serializableUserData.createdAt && serializableUserData.createdAt.toDate) {
              serializableUserData.createdAt = serializableUserData.createdAt.toDate().toISOString();
            }
            if (serializableUserData.lastVoteTime && serializableUserData.lastVoteTime.toDate) {
              serializableUserData.lastVoteTime = serializableUserData.lastVoteTime.toDate().toISOString();
            }
            
            dispatch(setUser(serializableUserData));
          }
        } catch (error) {
          console.error('Errore nel recupero dati utente:', error);
          if (isMounted) {
            dispatch(setUser({
              uid: firebaseUser.uid,
              email: firebaseUser.email,
            }));
          }
        }
      } else {
        // Se non c'è utente Firebase, pulisci lo stato
        if (isMounted) {
          dispatch(logout());
        }
      }
      
      if (isMounted) {
        dispatch(setLoading(false));
        setAuthChecked(true);
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [dispatch]);

  // Mostra loading durante il controllo iniziale dell'autenticazione
  if (loading || !authChecked) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Se l'autenticazione è stata controllata e l'utente non è autenticato
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;